import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/promotions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/promotions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/promotions/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/promotions/${data.promotion_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/promotions/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getMainProgram = (Options = {}) => {
  return httpClient
    .get('/api/promotions/main-programs')
    .then(response => Promise.resolve(response.data))
}

export const getSubProgram = acp_id => {
  return httpClient
    .get(`/api/promotions/sub-programs/${acp_id}`)
    .then(response => Promise.resolve(response.data))
}

export const getTerm = acps_id => {
  return httpClient
    .get(`/api/promotions/ac-terms/${acps_id}`)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getMainProgram,
  getSubProgram,
  getTerm
}
